import React from 'react'

export const IcoUpgrade = ({...props}) => {
  const style = props.style?props.style:{}
  return (
    <svg className='icon-upgrade' viewBox="0 0 24 24" {...props} style={{...style}}>
      <path d="M3.984 12l8.016-8.016 8.016 8.016-1.453 1.406-5.578-5.578v12.188h-1.969v-12.188l-5.625 5.578z"></path>
    </svg>
  )
}